import { LAYOUTS, POSITION, } from '@voltmoney/types';
import { ButtonTypeTokens, ButtonWidthTypeToken, ColorTokens, DividerSizeTokens, FontFamilyTokens, FontSizeTokens, IconSizeTokens, IconTokens, InputStateToken, InputTypeToken, InterestBounceType, KeyboardTypeToken, SizeTypeTokens, StackAlignContent, StackAlignItems, StackHeight, StackJustifyContent, StackSelfContent, StackType, StackWidth, TextInputTypeToken, WIDGET, } from '@voltmoney/schema';
import { ROUTE } from '../../../routes';
import { ACTION } from './types';
import { editAmount, goBack, leadToPayment, needHelp, onPageLoad, resetPage, unCheckPartialAmount, prefillPartialAmountAction, errorInstrument, navigateToSummaryScreen, navigateToDashboardScreen, trackSelectedPaymentType } from './actions';
import { addCommasToNumber, getUserContext, getParameters, showNewRepaymentFlowDc, getContactUsDetails, getBorrowerProfile, getCreditData, getForeClosureDetails } from '../../../configs/utils';
import { api } from '../../../configs/api';
import { getAppHeader } from '../../../configs/config';
import SharedPropsService from "../../../SharedPropsService";
import { Platform } from 'react-native';
import { LENDER_ID, LOAN_RENEWAL_FLOW_SHOW, TARGET_PAGES } from '../../../configs/constants';
import moment from 'moment';
export const template = async (principalLoanAmount, isFromDashboard, platformCode, isFromTransactions, showNewRepaymentFlow, height, contactUsDetails, preFilledAmount, isLoanExpired, approvedCreditAmount, lenderId) => {
    return {
        layout: {
            id: ROUTE.PAYMENT_START,
            type: LAYOUTS.LIST,
            style: {
                isPartnerPlatform: showNewRepaymentFlow ? true : false
            },
            widgets: showNewRepaymentFlow ? ([{ id: "newRepaymentScreen", type: WIDGET.FLEXI_REPAY }]) : ([
                Platform.OS === "ios" ? { id: "spaceXXL", type: WIDGET.SPACE, position: POSITION.ABSOLUTE_TOP } : {},
                {
                    id: 'customHeader',
                    type: WIDGET.CUSTOM_HEADER,
                    position: POSITION.ABSOLUTE_TOP,
                },
                {
                    id: 'totalAmountShowStack',
                    type: WIDGET.CARD,
                    padding: {
                        horizontal: 0,
                        all: 0,
                    },
                    position: POSITION.ABSOLUTE_TOP,
                },
                {
                    id: 'spaceXL',
                    type: WIDGET.SPACE,
                },
                {
                    id: 'titleStack',
                    type: WIDGET.STACK,
                },
                {
                    id: 'spaceXXL',
                    type: WIDGET.SPACE,
                },
                Platform.OS === "ios" ? { id: "space1XXL", type: WIDGET.SPACE } : {},
                {
                    id: 'fullAmountStackWithSpace',
                    type: WIDGET.STACK,
                },
                {
                    id: 'divider',
                    type: WIDGET.DIVIDER,
                },
                {
                    id: 'partialAmountFullStack',
                    type: WIDGET.STACK,
                },
                {
                    id: 'proceedButtonStack',
                    type: WIDGET.STACK,
                    position: POSITION.ABSOLUTE_BOTTOM,
                },
            ]),
        },
        datastore: {
            newRepaymentScreen: {
                height,
                principalLoanAmount,
                contactUsDetails,
                preFilledAmount,
                isLoanExpired,
                approvedCreditAmount,
                lenderId,
                navigateToSummaryScreenAction: {
                    type: ACTION.NAVIGATE_TO_SUMMARY_SCREEN,
                    routeId: ROUTE.PAYMENT_START,
                    payload: {},
                },
                goBackAction: {
                    type: ACTION.GO_BACK_ACTION,
                    routeId: ROUTE.PAYMENT_START,
                    payload: {},
                },
                trackPaymentSelectionAction: {
                    type: ACTION.TRACK_PAYMENT_SELECTION,
                    routeId: ROUTE.PAYMENT_START,
                    payload: {},
                },
            },
            customHeader: {
                title: "Flexi repay",
                needHelpAction: {
                    routeId: ROUTE.PAYMENT_START,
                    type: ACTION.NEED_HELP,
                    payload: { id: 'bt_paymentStart_needHelp', isFromDashboard: isFromDashboard }
                },
                hideNeedHelp: Platform.OS === 'web' ? false : true,
                goBackAction: {
                    routeId: ROUTE.PAYMENT_START,
                    type: ACTION.GO_BACK,
                    payload: { id: 'bt_flexiRepay_goBack', isFromDashboard: isFromDashboard, isFromTransactions: isFromTransactions }
                },
            },
            spaceNew: {
                size: SizeTypeTokens.XXXXXXL,
            },
            titleText: {
                label: 'Select amount for repayment',
                fontSize: FontSizeTokens.MD,
                fontWeight: '600',
                lineHeight: 24,
                color: ColorTokens.Grey_Night,
                fontFamily: FontFamilyTokens.Poppins
            },
            spaceXXL: {
                size: SizeTypeTokens.XXL,
            },
            space1XXL: {
                size: SizeTypeTokens.XXL,
            },
            spaceXXXL: {
                size: SizeTypeTokens.XXXL,
            },
            spaceXXXXL: {
                size: SizeTypeTokens.XXXXL,
            },
            titleStack: {
                type: StackType.column,
                width: StackWidth.FULL,
                widgetItems: [
                    {
                        id: 'titleText',
                        type: WIDGET.TEXT,
                        padding: {
                            right: 16,
                        },
                    },
                ],
            },
            selectFullAmountStack: {
                id: 'rb_flexiRepay_payFullAmount',
                type: StackType.row,
                width: StackWidth.FULL,
                alignContent: StackAlignContent.center,
                alignItems: StackAlignItems.center,
                ...platformCode === "TATADIGITAL" /* AppPlatform.TDL */ && { justifyContent: StackJustifyContent.spaceBetween },
                widgetItems: platformCode === "TATADIGITAL" /* AppPlatform.TDL */ ? [
                    { id: 'fullAmountStack', type: WIDGET.STACK },
                    { id: 'fullAmountRadio', type: WIDGET.ICON },
                ] : [
                    { id: 'spaceSM', type: WIDGET.SPACE },
                    { id: 'fullAmountRadio', type: WIDGET.ICON },
                    { id: 'spaceXXL', type: WIDGET.SPACE },
                    { id: 'fullAmountStack', type: WIDGET.STACK },
                ],
                action: {
                    type: ACTION.CHECKBOX_HANDLE,
                    payload: {
                        value: 'fullPay',
                    },
                    routeId: ROUTE.PAYMENT_START,
                },
            },
            fullAmountRadio: {
                name: IconTokens.RadioCircleNotFilled,
                size: IconSizeTokens.XXL,
            },
            partialAmountRadio: {
                name: IconTokens.RadioCircleNotFilled,
                size: IconSizeTokens.XXL,
            },
            fullAmountStack: {
                type: StackType.column,
                width: StackWidth.CONTENT,
                height: StackHeight.CONTENT,
                widgetItems: [
                    { id: 'fullAmountText', type: WIDGET.TEXT },
                ],
            },
            fullAmountStackWithSpace: {
                type: StackType.column,
                width: StackWidth.FULL,
                widgetItems: [
                    { id: "selectFullAmountStack", type: WIDGET.STACK },
                    {
                        id: 'spaceXL',
                        type: WIDGET.SPACE,
                    },
                ]
            },
            partialAmountFullStack: {
                type: StackType.column,
                width: StackWidth.FULL,
                widgetItems: [
                    {
                        id: 'spaceXL',
                        type: WIDGET.SPACE,
                    },
                    {
                        id: 'selectPartialAmountStack',
                        type: WIDGET.STACK,
                    },
                ],
            },
            selectPartialAmountStack: {
                id: 'rb_flexiRepay_payPartialAmount',
                type: StackType.row,
                width: StackWidth.FULL,
                ...platformCode === "TATADIGITAL" /* AppPlatform.TDL */ && { justifyContent: StackJustifyContent.spaceBetween },
                widgetItems: platformCode === "TATADIGITAL" /* AppPlatform.TDL */ ? [
                    { id: 'partialAmountText', type: WIDGET.TEXT },
                    { id: 'partialAmountRadio', type: WIDGET.ICON },
                ] : [
                    { id: 'spaceSM', type: WIDGET.SPACE },
                    { id: 'partialAmountRadio', type: WIDGET.ICON },
                    { id: 'spaceXXL', type: WIDGET.SPACE },
                    { id: 'partialAmountText', type: WIDGET.TEXT },
                ],
                action: {
                    type: ACTION.CHECKBOX_HANDLE,
                    payload: {
                        value: 'partialPay',
                    },
                    routeId: ROUTE.PAYMENT_START,
                },
            },
            divider: {
                size: DividerSizeTokens.MD,
                margin: {
                    all: SizeTypeTokens.XL,
                },
                color: ColorTokens.Grey_Milk,
            },
            spaceSM: {
                size: SizeTypeTokens.SM,
            },
            spaceLG: {
                size: SizeTypeTokens.LG,
            },
            spaceXL: {
                size: SizeTypeTokens.XL,
            },
            enterAmountFullStack: {
                type: StackType.column,
                width: StackWidth.FULL,
                padding: {
                    left: SizeTypeTokens.XXXXXL,
                    right: SizeTypeTokens.XXXXXXL,
                },
                widgetItems: [
                    { id: 'enterAmountInputStack', type: WIDGET.STACK },
                    { id: 'spaceLG', type: WIDGET.SPACE },
                ],
            },
            enterAmountInputStack: {
                type: StackType.row,
                padding: {
                    top: SizeTypeTokens.XXL,
                    right: SizeTypeTokens.XXXXXXL,
                },
                width: StackWidth.FULL,
                widgetItems: [{ id: 'input', type: WIDGET.INPUT }],
            },
            input: {
                type: InputTypeToken.DEFAULT,
                state: InputStateToken.DEFAULT,
                width: TextInputTypeToken.FULL,
                placeholder: '',
                title: 'Enter amount',
                charLimit: principalLoanAmount === null
                    ? 0
                    : principalLoanAmount.length,
                keyboardType: KeyboardTypeToken.numberPad,
                action: {
                    type: ACTION.EDIT_AMOUNT,
                    routeId: ROUTE.PAYMENT_START,
                    payload: { value: '' },
                },
            },
            fullAmountText: {
                label: 'Pay full amount',
                fontSize: FontSizeTokens.MD,
                fontWeight: '400',
                lineHeight: 24,
                fontFamily: FontFamilyTokens.Inter,
            },
            partialAmountText: {
                label: 'Pay partial amount',
                fontSize: FontSizeTokens.MD,
                fontWeight: '400',
                lineHeight: 24,
                fontFamily: FontFamilyTokens.Inter,
            },
            spaceXXXXXL: {
                size: SizeTypeTokens.XXXXXL,
            },
            proceedButtonStack: {
                width: StackWidth.FULL,
                type: StackType.column,
                justifyContent: StackJustifyContent.center,
                alignSelf: StackSelfContent.center,
                alignContent: StackAlignContent.center,
                alignItems: StackAlignItems.center,
                widgetItems: [
                    { id: 'amountPreview', type: WIDGET.SPACE },
                    { id: 'spaceSM', type: WIDGET.SPACE },
                    { id: 'proceedButton', type: WIDGET.BUTTON },
                ],
            },
            amountPreview: {
                size: SizeTypeTokens.MD,
            },
            proceedButton: {
                id: 'bt_flexiRepay_paymentMethod',
                action: {
                    type: ACTION.PAYMENT_DASHBOARD,
                    routeId: ROUTE.PAYMENT_START,
                    payload: {},
                },
                alignSelf: StackSelfContent.center,
                fontSize: FontSizeTokens.SM,
                fontWeight: '700',
                justifyContent: StackJustifyContent.center,
                label: 'Select payment method',
                type: ButtonTypeTokens.LargeOutline,
                width: ButtonWidthTypeToken.FULL,
            },
            totalAmountShowStack: {
                bgColor: platformCode === "TATADIGITAL" /* AppPlatform.TDL */ ? ColorTokens.TATA_NEU_BG_COLOR : ColorTokens.Grey_Milk,
                body: {
                    widgetItems: [
                        { id: 'totalAmountStack', type: WIDGET.STACK },
                    ],
                },
                alignItems: StackAlignItems.center,
                padding: {
                    bottom: SizeTypeTokens.NONE,
                },
                justifyContent: StackJustifyContent.spaceBetween,
            },
            totalAmountStack: {
                padding: { top: SizeTypeTokens.LG, bottom: SizeTypeTokens.LG },
                width: StackWidth.FULL,
                type: platformCode === "TATADIGITAL" /* AppPlatform.TDL */ ? StackType.row : StackType.column,
                alignItems: StackAlignItems.flexStart,
                ...platformCode === "TATADIGITAL" /* AppPlatform.TDL */ && { justifyContent: StackJustifyContent.spaceBetween },
                widgetItems: [
                    { id: 'totalAmountTitle', type: WIDGET.TEXT },
                    platformCode === "TATADIGITAL" /* AppPlatform.TDL */ ? {} : { id: 'space6', type: WIDGET.SPACE },
                    { id: 'totalAmountValue', type: WIDGET.TEXT },
                ],
            },
            totalAmountTitle: {
                label: 'Outstanding amount',
                fontFamily: FontFamilyTokens.Inter,
                fontWeight: '400',
                fontSize: FontSizeTokens.SM,
                color: ColorTokens.Grey_Charcoal,
                lineHeight: 20
            },
            totalAmountValue: {
                id: 'txt_flexiRepay_totalAmountValue',
                label: `₹${addCommasToNumber(Number(principalLoanAmount))}`,
                fontWeight: '600',
                fontSize: FontSizeTokens.MD,
                color: ColorTokens.Grey_Night,
                lineHeight: 24,
                fontFamily: FontFamilyTokens.Inter
            },
            spacePartialAmount: {
                padding: {
                    left: SizeTypeTokens.XXXXXL,
                    right: SizeTypeTokens.XXXXXXL,
                },
                size: SizeTypeTokens.XS,
            },
            space6: {
                size: SizeTypeTokens.Size6
            }
        },
    };
};
export const paymentStart = {
    onLoad: async (standardUtilities, { isFromDashboard, amount, isFromTransactions, collectionType, fromNeedHelp, amountToPay, target }) => {
        // const userContextResponse = await network.post(
        //     api.userContext,
        //     {},
        //     {headers: await getAppHeader()},
        // )
        let userContextResponse = await getUserContext(standardUtilities.network);
        userContextResponse.data = userContextResponse;
        const showNewRepaymentFlow = await showNewRepaymentFlowDc();
        const contactUsDetails = await getContactUsDetails();
        const url = Platform.OS === 'web' ? window.location.href : '';
        const params = getParameters(url);
        const platformCode = params?.platform || '';
        let principalLoanAmount = userContextResponse.data.linkedCredits[0].principalOutStandingAmount;
        const preFilledAmount = parseFloat(amount || amountToPay);
        const lenderId = userContextResponse?.linkedCredits[0]?.lendingPartnerId?.toLowerCase();
        // const response = await network.get(`${api.userProfile}${userContextResponse.data.linkedBorrowerAccounts[0].accountId}`, {
        //     headers: await getAppHeader(),
        // });
        // await SharedPropsService.setUser(userContextResponse.data)
        if (!showNewRepaymentFlow && ((isFromDashboard || isFromTransactions) || fromNeedHelp)) {
            prefillPartialAmountAction({
                type: ACTION.PRE_FILL_PARTIAL_AMOUNT,
                routeId: ROUTE.PAYMENT_START,
                payload: { amount: amount || amountToPay, collectionType: collectionType, principalLoanAmount: principalLoanAmount, fromNeedHelp: fromNeedHelp },
            }, {}, standardUtilities);
        }
        const height = standardUtilities.getHeight();
        const creditData = await getCreditData(standardUtilities.network);
        const config = await SharedPropsService.getFirebaseConfig();
        const loan_renewal_test_flag = config?.loan_renewal_test_flag;
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        //@ts-ignore
        let currentMoment = (loan_renewal_test_flag === true || loan_renewal_test_flag === 'true') ? await mockCurrentDate() : moment().startOf('day').unix() * 1000;
        currentMoment = moment();
        const renewalDate = creditData?.renewalDate;
        const isLoanExpired = currentMoment >= renewalDate ? true : false;
        if (await LOAN_RENEWAL_FLOW_SHOW() && isLoanExpired === true) {
            const getForeClosureData = await getForeClosureDetails(standardUtilities.network);
            if (getForeClosureData) {
                principalLoanAmount = getForeClosureData?.netPayable;
            }
            else {
                principalLoanAmount = userContextResponse?.data?.linkedCredits[0]?.netPayable;
            }
        }
        const approvedCreditAmount = userContextResponse?.data?.linkedCredits[0]?.approvedCreditAmount;
        if (target === TARGET_PAGES.REPAYMENT) {
            const userPaymentData = new Object();
            const isInterestRepaymentAllowed = await SharedPropsService.getFirebaseConfig().show_interest_repayment;
            const creditId = userContextResponse.data.linkedCredits[0].creditId;
            let response = await standardUtilities.network.get(`${api.getCredit}/${creditId}`, {
                headers: await getAppHeader(),
            });
            await SharedPropsService.setCreditData(response?.data);
            const repaymentAmount = response?.data?.principalOutStandingAmount;
            let interestResponse = await standardUtilities.network.get(`${api.interestDetails}${creditId}`, {
                headers: await getAppHeader(),
            }, null, {
                disableDefault: true
            });
            //@ts-ignore
            if (isInterestRepaymentAllowed === true || isInterestRepaymentAllowed === "true") {
                if (interestResponse.status === 200) {
                    userPaymentData.interestMonth = interestResponse?.data?.month;
                    userPaymentData.interestYear = interestResponse?.data?.year;
                    userPaymentData.isHavingInterestDue = true;
                    userPaymentData.interestDue = interestResponse?.data?.outstandingInterest;
                    userPaymentData.interestStatus = interestResponse?.data?.interestStatus;
                    userPaymentData.isMandateSetup = interestResponse?.data?.isMandateSetup;
                    userPaymentData.autoPayDate = interestResponse?.data?.autoPayDate;
                }
                else {
                    userPaymentData.interestMonth = '';
                    userPaymentData.interestYear = '';
                    userPaymentData.isHavingInterestDue = false;
                    userPaymentData.interestDue = 0;
                    userPaymentData.interestStatus = '';
                    userPaymentData.isMandateSetup = false;
                    userPaymentData.autoPayDate = '';
                }
            }
            const isShortfallDue = userContextResponse?.linkedCredits[0]?.isShortfallDue;
            let shortfallDetails;
            if (isShortfallDue) {
                const response = await standardUtilities.network.get(`${api.getShortfallDetails}/${creditId}`, {
                    headers: await getAppHeader(),
                });
                shortfallDetails = response?.data;
                userPaymentData.isHavingShortfall = true;
                userPaymentData.shortfallDue = shortfallDetails?.shortfallAmount;
                userPaymentData.recomendedShortfallAmount = shortfallDetails?.recommendedAmount;
            }
            else {
                userPaymentData.isHavingShortfall = false;
                userPaymentData.shortfallDue = 0;
            }
            userPaymentData.outstandingAmount = repaymentAmount;
            const isFromBajaj = userContextResponse?.linkedCredits[0]?.lendingPartnerId?.toLowerCase() === LENDER_ID.BAJAJ;
            let hardBreachDate = 15;
            userPaymentData.hardBreachDate = hardBreachDate;
            const currentDate = new Date();
            const currentDayOfMonth = currentDate.getDate();
            if (currentDayOfMonth >= hardBreachDate) {
                userPaymentData.interestState = InterestBounceType.HARD_DATE_BREACHED;
            }
            const userProfileResponse = await getBorrowerProfile(standardUtilities.network);
            let bankDetails = userProfileResponse?.bankDetails;
            userPaymentData.bankCode = bankDetails?.bankCode;
            userPaymentData.accountNumber = bankDetails?.accountNumber;
            userPaymentData.outstandingAmount = principalLoanAmount;
            await SharedPropsService.setPaymentData(userPaymentData);
        }
        return Promise.resolve(template(principalLoanAmount, isFromDashboard, platformCode, isFromTransactions, showNewRepaymentFlow, height, contactUsDetails, preFilledAmount, isLoanExpired, approvedCreditAmount, lenderId));
    },
    actions: {
        [ACTION.PAYMENT_DASHBOARD]: leadToPayment,
        [ACTION.EDIT_AMOUNT]: editAmount,
        [ACTION.CHECKBOX_HANDLE]: unCheckPartialAmount,
        [ACTION.ON_PAGE_LOAD]: onPageLoad,
        [ACTION.GO_BACK]: goBack,
        [ACTION.RESET_PAGE]: resetPage,
        [ACTION.NEED_HELP]: needHelp,
        [ACTION.PRE_FILL_PARTIAL_AMOUNT]: prefillPartialAmountAction,
        [ACTION.ERROR_INSTRUMENT]: errorInstrument,
        [ACTION.NAVIGATE_TO_SUMMARY_SCREEN]: navigateToSummaryScreen,
        [ACTION.GO_BACK_ACTION]: navigateToDashboardScreen,
        [ACTION.TRACK_PAYMENT_SELECTION]: trackSelectedPaymentType,
    },
    action: {
        type: ACTION.ON_PAGE_LOAD,
        routeId: ROUTE.PAYMENT_START,
        payload: {},
    },
};
